// extracted by mini-css-extract-plugin
module.exports = {"clockContainer":"clock_clockContainer__KjQlu","time":"clock_time__3GnD9","date":"clock_date__hYLrb"};